import {
  createLocalizationKey,
  IModal,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
  StepperCompletionMessageModal,
  ZendraLocalizationServices,
} from '@zendra/shared';

export const COMPLETE_STEPPER_MESSAGE: IModal = {
  asideConfig: { show: false },
  confirmLabel: createLocalizationKey('Confirm', ZendraLocalizationServices.LanguageService),
  dismissLabel: createLocalizationKey('Close', ZendraLocalizationServices.LanguageService),
  backdrop: 'static',
  size: 'md',
  title: createLocalizationKey(
    'StandCycleRotationHarvestPreparation.StepInventoryValidation.CompletedConfirmationMessage',
    ZendraLocalizationServices.Geographic,
  ),
  component: StepperCompletionMessageModal,
  inputs: {
    message: createLocalizationKey(
      'StandCycleRotationHarvestPreparation.StepInventoryValidation.CompletedMessage',
      ZendraLocalizationServices.Geographic,
    ),
  },
};

export const HARVESTPREPARATIONSTANDCYCLEROTATION_CONFIG = {
  entityName: 'StandCycleRotation',
  localizationKey: 'Geographic::StandCycleRotationHarvestPreparation',
  permission: 'PlanningGeography.StandCycleRotations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsPlanning + MENU_NAME_SUFFIX,
};
